// Ediary model
export interface MyEdiary {
  activity?: Array<MyEdiaryActivity>;
  unformattedActivity?: Array<any>;
}

export interface MyEdiaryTimelineActivity {
  year: string;
  month: string;
  activityBlockTitle: string;
  monthData: Array<MyEdiaryMonthDailyActivity>;
}

export interface MyEdiaryMonthDailyActivity {
  day: string;
  dayName: string;
  dailyData: Array<MyEdiaryActivity>;
}

export interface MyEdiaryActivity {
  id: string;
  type: string;
  title: string;
  ediary_date: string;
  occurrence: string | number;
  href: string;
  icon: string;
  isActiveDay: boolean;
  repeat_rule: string;
  status: number;
}

// TODO: Use this while parsing and assigning status
export enum EdiaryStatus {
  'status_ready',
  'status_early',
  'status_ongoing',
  'status_completed',
  'status_outdated'
}
